<template>
  <ModalContainer queryParam="f024" ref="modalContainer" size="lg">
    <b-alert
      v-if="messageAlert"
      show
      :variant="messageAlert.variant"
      class="p-2 text-center"
    >
      {{ messageAlert.text }}
    </b-alert>

    <b-card class="mb-1">
      <h4 class="text-primary text-center mb-3">CONSENTIMIENTO INFORMADO</h4>

      <div class="row">
        <div class="col">
          <b>Procedimiento:</b> {{ dataProceso.codigo }} -
          {{ dataProceso.descripcion }}
        </div>
        <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
      </div>

      <hr />

      <b-row>
        <div class="col-6 mb-2 d-flex">
          <b class="mr-1"> Tipo de Atencion: </b>

          <b-form-radio-group v-model="dataForm.tipoAtencion">
            <b-form-radio value="a">Ambulatorio</b-form-radio>
            <b-form-radio value="h">Hospitalización</b-form-radio>
          </b-form-radio-group>
        </div>
        <div class="col-6 mb-2 d-flex">
          <b class="mr-1"> Tipo de Anestesia: </b>

          <b-form-radio-group v-model="dataForm.tipoAnestesia">
            <b-form-radio value="x">No aplica</b-form-radio>
            <b-form-radio value="1">Local</b-form-radio>
            <b-form-radio value="2">Sedación</b-form-radio>
            <b-form-radio value="3">Tópica</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-row>

      <span><b>Diagnostico:</b></span>
      <b-row class="d-flex align-items-center mt-1">
        <SearchOpts
          v-model="searchDiagnostico"
          :searchService="diagnosticosService.getByQuerySelect"
          :minChars="3"
          :placeholder="'Buscar diagnostico...'"
          class="col-7"
        />

        <b-col cols="2">
          <b-button variant="warning" @click="agregarDiagnostico" size="sm">
            <i class="fa-solid fa-plus" />
          </b-button>
        </b-col>

        <b-col class="mt-1" cols="12">
          <b-table
            v-if="diagnosticosList.length"
            small
            :items="diagnosticosList"
            :fields="fieldsConsentimiento"
          >
            <template #cell(acciones)="data">
              <b-button
                @click="eliminarRegistro(data.index)"
                variant="danger"
                size="sm"
              >
                <i class="fa-solid fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <!-- 

      <hr />
        <div class="row mt-2">
            <div class="col-4 d-flex align-items-center">
              <label class="mr-1">Fecha: </label>
              <flat-pickr size="sm" class="form-control form-control-sm" v-model="dataForm.fechaActual" locale="es"
                :config="birthDateConfig" />
            </div>

            <div class="offset-1 col-4 d-flex align-items-center">
              <label class="mr-1">Hora: </label>
                <vue-timepicker v-model="dataForm.horaActual" fixed-dropdown-button format="HH:mm" manual-input>
                    <template v-slot:dropdownButton>
                      <i class="fa-regular fa-clock"></i>
                    </template>

                  </vue-timepicker>
               <b-timepicker v-model="dataForm.horaActual" locale="es" format="HH:mm" size="sm" /> 
            </div>
          </div>

          <b-row class="my-2 align-items-center">
            <b-col>
              <label>Cirujano:</label>
            <SearchOpts  v-model="doctor" :searchService="doctoresService.searchDoctoresByTermSelect"
              :placeholder="'Buscar cirujano...'" class="col-10 form-control-sm" :minChars="3" />
            </b-col>
            </b-row>
          <hr/> -->

      <b-tabs
        small
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        active-tab-class="font-weight-bold text-dark"
      >
        <b-tab title="Descripciones">
          <div class="mb-1">
            <b> En que consiste?: </b>
            <b-form-textarea
              rows="3"
              max-rows="6"
              v-model="dataForm.descripcion"
            />
          </div>

          <div class="mb-1">
            <b> Como se realiza?: </b>
            <b-form-textarea
              rows="3"
              max-rows="6"
              v-model="dataForm.realizacion"
            />
          </div>

          <b-row>
            <b-col>
              <b> Gráfico de la intervención: </b>

              <b-form-checkbox
                class="mt-1"
                v-model="uploadImage"
                switch
                size="md"
              >
                Subir imagen
              </b-form-checkbox>

              <div>
                <div v-if="!uploadImage">
                  <b-img
                    :src="urlFileToView(dataForm.rutaImg)"
                    height="200px"
                    width="200px"
                  ></b-img>
                </div>
                <div v-else class="mt-1">
                  <b-form-file
                    v-model="imgprocedimiento"
                    :state="Boolean(imgprocedimiento)"
                    placeholder="Escoja o arrastre el archivo aqui..."
                    drop-placeholder="Coloquelo aqui..."
                    accept=".jpg, .jpeg, .png"
                    @change="onFileChange($event)"
                  />
                  <div class="text-center mt-1">
                    <b-img
                      v-if="imgSrc"
                      :src="imgSrc"
                      height="200px"
                      width="200px"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <b-col>
              <div>
                <b> Duracion estimada </b>
                <b-form-input v-model="dataForm.duracion" />
              </div>

              <div class="mt-1">
                <b> Beneficios del procedimiento </b>
                <b-form-textarea v-model="dataForm.beneficios" />
              </div>

              <div>
                <b> Alternativas al procedimiento </b>
                <b-form-textarea v-model="dataForm.alternativas" />
              </div>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="Riesgos">
          <b-row class="mt-1">
            <b-col>
              <div>
                <b> Riesgos poco frecuentes (graves) </b>
                <b-form-textarea v-model="dataForm.riesgosGraves" />
              </div>
              <div class="mt-2">
                <b> Riesgos especificos del paciente </b>
                <b-form-textarea v-model="dataForm.riesgosEspecificos" />
              </div>
            </b-col>

            <b-col>
              <b> Riesgos frecuentes </b>
              <b-form-textarea rows="6" v-model="dataForm.riesgosFrecuentes" />
            </b-col>
          </b-row>
          <div class="row">
            <div class="mt-2 col">
              <b> Manejo posterior </b>
              <b-form-textarea v-model="dataForm.manejoPosterior" />
            </div>

            <div class="mt-2 col">
              <b> Consecuencias si no se realizara </b>
              <b-form-textarea v-model="dataForm.consecuencias" />
            </div>
          </div>
          <hr />

          <b-row class="mt-1">
            <div class="col">
              <b>El paciente </b>
              <b>una vez leído el documento: </b>
              <b-form-radio-group
                class="mt-1"
                v-model="dataForm.aceptaConsentimiento"
                :options="optionsCheckFirma"
              />
            </div>
          </b-row>

          <b-row class="mt-1 align-items-center">
            <div class="col">
              <b>Medico que realiza la intervención:</b>

              <div v-if="dataForm && dataForm.doctor">
                <b-input-group class="mb-2">
                  <b-form-input size="sm" v-model="dataForm.doctor.text" />
                  <b-input-group-append>
                    <b-button
                      variant="danger"
                      @click="dataForm.doctor = null"
                      title="Eliminar y elegir otro"
                      size="sm"
                    >
                      <i class="fa-solid fa-trash" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>

              <SearchOpts
                v-else
                v-model="dataForm.doctor"
                :searchService="doctoresService.searchDoctoresByTermSelect"
                :placeholder="'Buscar cirujano...'"
                class="col-10 form-control-sm"
                :minChars="3"
              />
            </div>
          </b-row>
        </b-tab>

        <!-- <b-tab title="Firma">
          <div class="row mt-2">
            <div class="col-4 d-flex align-items-center">
              <label class="mr-1">Fecha: </label>
              <flat-pickr size="sm" class="form-control form-control-sm" v-model="dataForm.fechaActual" locale="es"
                :config="birthDateConfig" />
            </div>

            <div class="offset-1 col-4 d-flex align-items-center">
              <label class="mr-1">Hora: </label>
              <b-timepicker v-model="dataForm.horaActual" locale="es" format="HH:mm" size="sm" />
            </div>
          </div>

          <b-row class="my-2 align-items-center">
            <label>Cirujano:</label>
            <b-col md="8" v-if="dataForm && dataForm.doctor">
              <div>
                <b-input-group class="mb-2">
                  <b-form-input size="sm" v-model="dataForm.doctor.text" />
                  <b-input-group-append>
                    <b-button variant="danger" @click="dataForm.doctor = null" title="Eliminar y elegir otro" size="sm">
                      <i class="fa-solid fa-trash" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>

            <SearchOpts v-else v-model="dataForm.doctor" :searchService="doctoresService.searchDoctoresByTermSelect"
              :placeholder="'Buscar cirujano...'" class="col-10 form-control-sm" :minChars="3" />
          </b-row>

          <div class="text-left mt-3">
            <b>Una vez leído el documento la persona: </b>
            <b-form-radio-group class="mt-1" v-model="dataForm.aceptaConsentimiento" :options="optionsCheckFirma" />
          </div>

          <div class="mt-2">
            <b>Agregar firma del:</b>
            <b-form-radio-group class="mt-1" v-model="dataForm.signaturePersona" name="radio-sub-component">
              <b-form-radio value="1" @change="dataForm.parentesco = ''">
                Paciente
              </b-form-radio>

              <b-form-radio value="2">Representante legal</b-form-radio>

              <b-form-radio v-if="dataForm.aceptaConsentimiento === 2" value="3"
                @change="dataForm.parentesco = ''">Testigo</b-form-radio>

            </b-form-radio-group>


            <div class="mt-1" v-if="dataForm.signaturePersona === '2'">
              <b>Parentesco: </b>
              <b-form-input v-model="dataForm.parentesco" />
            </div>

            <div class="mt-1" v-if="dataForm.signaturePersona === '3'">
              <b>Ingrese la informacion del testigo: </b>
              <b-row class="mt-1">
                <b-col cols="8">
                  <b-form-input placeholder="Ingrese los nombres" v-model="dataForm.testigoNombres">
                  </b-form-input>
                </b-col>
                <b-col cols="4">
                  <b-form-input placeholder="Ingrese la identificacion" v-model="dataForm.testigoId" />
                </b-col>
              </b-row>
            </div>
          </div>

          <ProcessSignature v-if="dataForm.signaturePersona" :base64Signature="dataForm.signatureBlob"
            @signatureBlob="firmaRecibida" />
        </b-tab> -->
      </b-tabs>

      <div class="mt-2 d-flex justify-content-end">
        <b-button variant="primary" @click="onSaveForm"> Guardar </b-button>

        <b-button class="ml-2">Cancelar</b-button>
      </div>
    </b-card>
  </ModalContainer>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { diagnosticosService } from "../../../atencionMedica/services";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { doctoresService } from "@/shared/services";
import { infoDataConsentimiento } from "./dataConsentimiento";
import { fileService } from "../../../../shared/services";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import { ProcessSignature } from "../../../topaz/components";
import {
  procedimientosFormulariosService,
  procedimientosService,
} from "../../services";
import { dataForms } from "../../constants/dataForms";
import rutas from "@/assets/utils/rutas.json";

export default {
  components: {
    flatPickr,
    SearchOpts,
    ModalContainer,
    ProcessSignature,
    VueTimepicker,
  },
  props: {
    dataProcedimiento: {
      type: Object,
      default: null, // Valor por defecto si no se proporciona
    },
    consInformado: {
      type: Object,
      default: null, // Valor por defecto si no se proporciona
    },
  },

  data() {
    return {
      fieldsConsentimiento: [
        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },

        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
      searchDiagnostico: null,
      diagnosticosService,
      imgSrc: null,
      uploadImage: false,
      imgprocedimiento: null,
      diagnosticosList: [],

      topazVisible: false,
      idRegistroForm: null,
      messageAlert: null,

      checkFirma: 1,
      optionsCheckFirma: [
        { text: "ACEPTA ", value: 1 },
        { text: "SE NIEGA", value: 2 },
        { text: "REVOCA ", value: 3 },
      ],
      diagnosticosearch: null,

      infoDataConsentimiento,

      dataProceso: {
        codigo: "",
        procedimiento: "",
        paciente: "",
      },

      doctor: null,

      dataForm: {
        descripcion: "",
        realizacion: "",
        duracion: "",
        beneficios: "",
        alternativas: "",
        rutaImg: "",
        imagen_b64: null,
        tipoAnestesia: "x",
        tipoAtencion: "a",
        diagnosticosList: [],
        doctor: null,
      },

      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },

      tokenFormulario: null,

      doctoresService,
    };
  },
  created() {
    this.setDate();
    this.loadData();
  },

  methods: {
    onFileChange(event) {
      const file = event.target.files[0];

      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(file.type)) {
        this.$swal.fire({
          icon: "error",
          text:
            "Solo se permiten archivos en formato jpg o png no en este formato => " +
            file.type,
        });
        this.imgprocedimiento = null;
        event.target.value = null; // Limpia el input
        return;
      }
      console.log("este es el file", file);
      this.imgprocedimiento = file;
    },

    urlFileToView(rutaRecibida) {
      const ruta = `${rutas.axios}file/show${rutaRecibida}`;
      return ruta;
    },

    eliminarRegistro(index) {
      this.diagnosticosList.splice(index, 1);
    },
    agregarDiagnostico() {
      if (!this.searchDiagnostico) {
        this.$swal.fire({
          icon: "info",
          text: "Escoja un diagnostico",
        });

        return;
      }

      const dataTable = this.diagnosticosList;

      if (dataTable && dataTable.length > 0) {
        this.$swal.fire({
          icon: "info",
          text: "Ya existe un diagnostico agregado, debe eliminar el existente",
        });
        this.searchDiagnostico = null;

        return;
      }

      this.diagnosticosList.push({
        diagnostico: this.searchDiagnostico.text,
        diagObject: this.searchDiagnostico,
      });
      console.log("agrega diagnostico", this.diagnosticosList);

      this.searchDiagnostico = null;
    },

    setDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual =
        now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },

    async loadData() {
      this.tokenProceso = this.$route.query?.forms;
      this.tokenFormulario = this.$route.query?.f024;

      if (!this.tokenProceso) return;

      const responseDataProceso = await procedimientosService.getByToken(
        this.tokenProceso
      );

      if (responseDataProceso) {
        const persona =
          responseDataProceso.consultamedica.cita.paciente.persona;

        if(responseDataProceso.procedimientoOdonto){
          this.dataProceso = {
          codigo: responseDataProceso.procedimientoOdonto.codigo,
          descripcion: responseDataProceso.procedimientoOdonto.descripcion,
          paciente: `${persona.identificacion} - ${persona.primerApellido} ${persona.primerNombre}`,
        };
        }else {
 this.dataProceso = {
          codigo: responseDataProceso.procedimiento.codigo,
          descripcion: responseDataProceso.procedimiento.descripcion,
          paciente: `${persona.identificacion} - ${persona.primerApellido} ${persona.primerNombre}`,
        };
        }

       
      }

      const responseDataForm =
        await procedimientosFormulariosService.obtenerFormProcDataByToken(
          this.tokenFormulario
        );

      if (!responseDataForm) {
        this.messageAlert = {
          text: "No se encontro informacion registrada se creara un nuevo registro",
          variant: "info",
        };

        console.log("dataproceso", responseDataProceso)

        let codigo_procedimiento = responseDataProceso.procedimiento ? responseDataProceso.procedimiento : responseDataProceso.procedimientoOdonto;
        

        const dataBaseConsentimiento =
          await procedimientosService.obtenerDataBaseConsentimiento(
            codigo_procedimiento.codigo,
            codigo_procedimiento.descripcion
          );
        if (dataBaseConsentimiento) {
          this.dataForm = dataBaseConsentimiento;
          this.dataForm.diagnosticosList = [];
          this.dataForm.doctor = null;
          this.dataForm.riesgosEspecificos = "";

          if (dataBaseConsentimiento && dataBaseConsentimiento.imagen_b64) {
            this.dataForm.imagen_b64 = dataBaseConsentimiento.imagen_b64;
          }
        } else {

          console.log("ENTRA A INFO DATA CONSENTIMIENTO", this.dataProceso.codigo)
          const dataFormDefault = infoDataConsentimiento.dataConsentimiento(
            this.dataProceso.codigo,
            this.dataProceso.descripcion
          );
          this.dataForm = dataFormDefault;
          this.dataForm.diagnosticosList = [];
          this.dataForm.doctor = null;
        }
        return;
      }

      const dataResponse = responseDataForm;
      this.idRegistroForm = dataResponse.id;
      delete dataResponse.id;

      const dataForm = JSON.parse(dataResponse.dataJson);
      this.dataForm = dataForm;

      this.messageAlert = {
        text: "Se cargo la informacion registrada",
        variant: "success",
      };
    },

    firmaRecibida(blob) {
      this.dataForm.signatureBlob = blob;
    },

    onShowTopaz() {
      this.topazVisible = !this.topazVisible;
    },

    convertToBase64(file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.imgSrc = reader.result;
      };
      reader.readAsDataURL(file);
    },

    async convertToBase64FromURL(url) {
      const response = await fetch(url); // Obtener la imagen desde la URL
      const arrayBuffer = await response.arrayBuffer(); // Obtener los datos binarios de la imagen

      // Convertir el ArrayBuffer a Base64
      let base64String = btoa(
        String.fromCharCode(...new Uint8Array(arrayBuffer))
      ); // Convierte a Base64

      return `data:image/jpeg;base64,${base64String}`; // Asegúrate de agregar el prefijo adecuado para imágenes JPEG (o el tipo de imagen que estés usando)
    },
    async fileFromLocalUrl(url, filename) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new File([blob], filename, { type: blob.type });
    },

    async onSaveForm() {
      //   if (!this.uploadImage && this.dataForm.rutaImg) {
      // const localPath = this.dataForm.rutaImg; // ej. '/imagenesProcedimientos/img-colposcopia.jpg'
      // const fileName = localPath.split('/').pop(); // 'img-colposcopia.jpg'
      //   }

      const dataTable = this.dataForm.diagnosticosList;
      console.log("data table", dataTable);
      if (!dataTable || dataTable.length < 1) {
        this.$swal.fire({
          icon: "info",
          text: "Debe agregar un diagnostico al menos",
        });
        return;
      }

      if (this.imgprocedimiento && this.uploadImage) {
        try {
          this.dataForm.rutaImg = await fileService.upload(
            "imagenesConsentimiento",
            this.imgprocedimiento,
            "img"
          );
        } catch (error) {
          console.log("error", error);
        }
      }

      // try {
      //   const file = await this.fileFromLocalUrl(localPath, fileName);

      //   // Usa tu función personalizada `upload`
      //   const newUrl = await fileService.upload("procedimientos", file, "consentimiento");

      //   if (newUrl) {
      //     this.dataForm.rutaImg = newUrl;
      //   } else {
      //     this.$swal.fire({
      //       icon: "error",
      //       text: "Error al subir la imagen local",
      //     });
      //     return;
      //   }
      // } catch (e) {
      //   console.error("Error cargando archivo desde ruta local", e);
      //   return;
      // }

      const dataJson = JSON.stringify(this.dataForm);

      const params = {
        nameForm: "024",
        dataJson: dataJson,
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm,
      };

      const responseSave = await procedimientosFormulariosService.guardarData(
        params
      );

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "Ocurrio un error al guardar",
          icon: "error",
          confirmButtonColor: "#089599",
        });
        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

      this.imgprocedimiento = null;
      this.uploadImage = false;

      this.$emit("formulario-guardado");

      await this.$router.push({
        query: { ...this.$route.query, f024: undefined },
      });

      //this.$router.go(0);
    },
  },

  watch: {
    imgprocedimiento: {
      deep: true,
      inmediate: true,
      handler(newValue) {
        if (newValue) {
          console.log("imgproc watch", newValue);
          this.convertToBase64(newValue);
        } else {
          this.imgSrc = null;
        }
      },
    },

    "$route.query.f024": {
      handler(newValue) {
        if (newValue) {
          this.loadData();
        }
      },
    },

    "dataForm.horaActual": {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.HH && newValue.mm) {
          this.dataForm.horaActual = `${newValue.HH}:${newValue.mm}`;
        }
      },
    },

    "dataForm.doctor": {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.doctor = newValue;
        }
      },
    },

    doctor: {
      immediate: true,
      deep: true,
      handler(newValue) {
        console.log("dataForm antes doctor", this.dataForm);
        console.log("doctor", newValue);
        this.dataForm.doctor = newValue;
      },
    },

    diagnosticosList: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.dataForm.diagnosticosList = newValue;
        }
      },
    },
  },
};
</script>
